<template>
  <div>
    <v-autocomplete
      ref="autocomplete"
      :clearable="!readonly"
      :search-input.sync="search"
      :items="options"
      v-model="innerValue"
      item-text="text"
      item-value="value"
      :solo="solo"
      :filter="filterMe"
      @keypress="clearMe"
      @change="changeMe"
      :loading="loading"
      :readonly="loading || readonly"
      :no-data-text="textInfo"
      :disabled="disabled"
      :hide-details="hideDetails"
      v-bind="resetProps"
    >
    </v-autocomplete>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import _ from "lodash";

export default {
  props: {
    value: [Object, String, Number, Array],
    solo: Boolean,
    hideDetails: Boolean,
    dense: Boolean,
    disabled: Boolean,
    readonly: Boolean
  },

  data() {
    return {
      innerValue: this.value,
      search: null,
      entries: [],
      loading: false,
      selected: null,
      clientLoading:false
    };
  },

  async mounted() {
      if (this.value) {        
        await this.loadClient();
      }
  },

  watch: {
    async value(n) {
      if (n) {
        await this.loadClient();
      }
      this.innerValue = n;      
    },
    innerValue(value) {
      this.$emit("input", value);
    },
    search: _.debounce(async function (newSearch, oldTerm) {
      if (newSearch === oldTerm) return;
      if (!newSearch || newSearch.length < 1) return;
      if (this.loading) return;
      if (this.selected !== null) return;
      this.loading = true;
      await this.filter({
        PageSize: 1000,
        PageNumber: 1,
        SearchTerm: newSearch,
        OrderBy: "companyName",
        Ascending: true,
      });
      this.loading = false;
    }, 500),
  },

  methods: {
    ...mapActions("client", ["filter", "getByIdOption"]),


    async loadClient(){
      if (this.clientLoading===true) {
        return;
      }
      this.clientLoading=true;
      if (typeof this.value !== 'object') {
      await this.getByIdOption(this.value);
      }      
      this.clientLoading=false;
    },

    filterMe(x) {
      return x;
    },
    changeMe(m) {
      this.selected = m;
      this.$emit("change");
    },
    clearMe() {
      this.selected = null;
    },
  },

  computed: {
    ...mapState({
      client: (state) => state.client,
    }),
    resetProps() {
      return { ...this.$attrs };
    },
    textInfo() {
      if (!this.search) {
        return `Start typing ...`;
      }
      if (
        this.selected === null &&
        !this.loading &&
        this.options.length === 0 &&
        this.search === null
      ) {
        return "Start type any keyword to search";
      } else if (this.loading === true) {
        return `Searching ${this.search}...`;
      } else {
        return `No client found with "${this.search}".`;
      }
    },

    initialValue() {
      return this.value && this.client.singleOption ? [this.client.singleOption] : [];
    },

    dataOptions() {
      return this.value || this.search ? [...this.client.dataOptions] : [];
    },

    options() {
      let entries = [...this.initialValue, ...this.dataOptions];
      return entries
        .filter((item) => item.id)
        .map((client) => {
          let { id, companyName } = client;

          // let name =
          //   companyName === `${firstName} ${lastName}`
          //     ? companyName
          //     : `${companyName} (${firstName} ${lastName})`;
          return {
            value: id,
            text: companyName,
          };
        });
    },
  },
};
</script>